import ckTheme from './cloudkitchens';
import entitiesSharedColors from './entitiesSharedColors';

const mono = '#6EC5CC';
const monoContrast = '#FFFFFF';
const monoDark = '#1B6C7E';
const monoLight = '#6EC5CC';

export default {
  colors: {
    ...ckTheme.colors,
    primary: monoLight,
    'primary-dark': monoDark,
    'primary-light': monoLight,
    'primary-contrast': monoContrast,
    secondary: monoDark,
    'secondary-dark': monoDark,
    'secondary-light': monoLight,
    'secondary-contrast': monoContrast,
    tertiary: mono,
    'tertiary-dark': monoDark,
    'tertiary-light': monoLight,
    'tertiary-contrast': monoContrast,
    'accent-1': monoLight,
    ...entitiesSharedColors,
  },
  fonts: {},
};
